export const getUnreadMessagesCount = (conversations) => {
  if (!Array.isArray(conversations)) return 0;

  return conversations.reduce((total, conv) => {
    const unread = conv?.unread || 0;
    return total + unread;
  }, 0);
};
